var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission)?_c('div',[_c('crm-form')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }